/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Column } from '../models/Column';
import type { DatasetPayload } from '../models/DatasetPayload';
import type { FeatureFlag } from '../models/FeatureFlag';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class InternalService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns any Ok
     * @throws ApiError
     */
    public postUsageRecord(): CancelablePromise<{
        data: string;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/internal/customer/usage',
        });
    }
    /**
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public postAuth0(
        requestBody: any,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/internal/auth0',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any Ok
     * @throws ApiError
     */
    public auth0CurrentSubscription(
        requestBody: {
            user_id: string;
        },
    ): CancelablePromise<{
        data: {
            paused_on: string | null;
            external_feature_flags: Array<FeatureFlag>;
            internal_feature_flags: Array<FeatureFlag>;
            limited_access: boolean;
            property_report_seats: number;
            products: Array<string>;
        };
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/internal/current_subscription',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns boolean Ok
     * @throws ApiError
     */
    public queuePropertyReportEmails(): CancelablePromise<boolean> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/internal/queue_property_report_emails',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public fillBulkDataQueue(): CancelablePromise<{
        failed: number;
        succeeded: number;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/internal/queue_bulk_data_emails',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public fillDatasetQueue(): CancelablePromise<{
        failed: number;
        succeeded: number;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/internal/queue_dataset_emails',
        });
    }
    /**
     * @param requestBody
     * @returns boolean Ok
     * @throws ApiError
     */
    public sendPropertyReportEmail(
        requestBody: {
            id: number;
            user_id: string;
        },
    ): CancelablePromise<boolean> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/internal/send_property_report_email',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any Ok
     * @throws ApiError
     */
    public sendDatasetEmailDetailed(
        requestBody: {
            markAsSent?: {
                datasetId: number;
                cron_expression: string;
            };
            format: 'csv' | 'jsonl';
            name: string;
            emails: Array<string>;
            payload: DatasetPayload;
        },
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/internal/send_dataset_email',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param col
     * @returns any Ok
     * @throws ApiError
     */
    public healthCheck(
        col?: Column,
    ): CancelablePromise<{
        col?: Column;
        data: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/internal/health',
            query: {
                'col': col,
            },
        });
    }
}
